"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAT_LON_REGEX = void 0;
/**
 * Regular expression for validating latitude and longitude coordinates in the format "lat,lon"
 * where both lat and lon are decimal numbers with optional negative sign
 */
exports.LAT_LON_REGEX = /^-?[0-9]+\.[0-9]+,-?[0-9]+\.[0-9]+$/;
//# sourceMappingURL=validation.js.map